import React from 'react';
import { PopCatCarousel } from './pop-cat-carousel';
import { PopCatItem } from './pop-cat-item';
import { PopCatGrid } from './pop-cat-grid';
import { PopCatGridItem } from './pop-cat-grid-item';
import { StartPageSection } from '../start-page-section/start-page-section';
import { StartPageSectionTitle } from '../start-page-section/start-page-section-title';

export const PopularCategories = ({
    containerType,
    data,
    inSPA,
    videoEnabled
}) => {
    const { items, hiddenOn, type } = data;

    if (hiddenOn?.includes('Web') || items.length === 0) {
        return null;
    }

    if (typeof type !== 'string') return null;

    return (
        <StartPageSection>
            {data.title && (
                <StartPageSectionTitle>{data.title}</StartPageSectionTitle>
            )}
            {type === 'Grid' ? (
                <PopCatGrid>
                    {items.map((item, index) => (
                        <PopCatGridItem
                            key={`${item.id}-${index}`}
                            inSPA={inSPA}
                            item={item}
                            itemCount={items.length}
                            containerType={containerType}
                            videoEnabled={videoEnabled}
                            itemHeadersAsImageOverlay={
                                data.itemHeadersAsImageOverlay
                            }
                        />
                    ))}
                </PopCatGrid>
            ) : (
                <PopCatCarousel orientation={data.type}>
                    {items.map((item, index) => (
                        <PopCatItem
                            key={`${item.id}-${index}`}
                            inSPA={inSPA}
                            item={item}
                            itemCount={items.length}
                            containerType={containerType}
                            videoEnabled={videoEnabled}
                            totalCount={items.length}
                            type={data.type}
                        />
                    ))}
                </PopCatCarousel>
            )}
        </StartPageSection>
    );
};
